import ForMeTab    from "./feed/forMeTab";
import ActivityTab from "./feed/activityTab";
import UpdatesTab  from "./feed/updatesTab";

const component = props => {
	const {
		activeTab,
		activeUpdateTab,
		marked,
		clickImpression,
		viewImpression,
		handleMarkAllRead
	} = props;

	if ( activeTab === "ACTIVITY" )
		return (
			<ActivityTab
				activeTab       = { activeTab }
				clickImpression = { clickImpression }
				viewImpression  = { viewImpression }
			/>
		);

	if ( activeTab === "UPDATES" )
		return (
			<UpdatesTab
				activeTab       = { activeTab }
				activeUpdateTab = { activeUpdateTab }
				clickImpression = { clickImpression }
				viewImpression  = { viewImpression }
			/>
		);

	return (
		<ForMeTab
			activeTab       = { activeTab }
			clickImpression = { clickImpression }
			handleMarkAllRead = { handleMarkAllRead }
			marked          = { marked }
			viewImpression  = { viewImpression }
		/>
	);
};

export default component;
